import styled from 'styled-components'
import { TextField, PhoneInput } from '@dsny/dsny-component-library'
import {
  LEGACY_BREAKPOINT_QUERIES,
  createResponsiveBreakpointQuery
} from 'styles/breakpoints'

const mobileQuery = createResponsiveBreakpointQuery('mobileDown', {
  legacyQuery: LEGACY_BREAKPOINT_QUERIES.mobileDown
})

const twoColumnQuery = createResponsiveBreakpointQuery('tabletUp', {
  legacyQuery: LEGACY_BREAKPOINT_QUERIES.reactGridSmallUp
})

export const StyledTextField = styled(TextField).attrs(({ theme, error }) => ({
  inputStyle: {
    height: 44,
    borderColor: error ? theme.colors.error70 : theme.colors.neutralW50,
    paddingLeft: 10
  },
  wrapperStyles: { paddingRight: 0, marginBottom: 0 },
  errorStyle: {
    color: theme.colors.error70,
    paddingTop: 5
  },
  setting: 'player'
}))``

export const StyledPhoneInput = styled(PhoneInput).attrs(
  ({ theme, error }) => ({
    inputStyle: {
      height: 44,
      borderColor: error ? theme.colors.error70 : theme.colors.neutralW50,
      width: 'calc(100% - 10px)'
    },
    errorStyle: {
      color: theme.colors.error70,
      paddingTop: 5
    },
    wrapperStyles: {
      marginBottom: 15,
      paddingRight: 0,
      maxWidth: '100%'
    },
    setting: 'player'
  })
)``

export const SignUpStepsCounter = styled.div`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 700;
  color: ${({ theme }) => theme.colors.neutralW70};
  margin-bottom: 16px;
  span {
    color: ${({ theme }) => theme.colors.neutralW60};
    margin-left: 4px;
  }
`

export const Error = styled.p`
  font-size: 12px;
  margin-top: 8px;
  color: ${({ theme }) => theme.colors.error70};
`

export const SignupHalfColumn = styled.div`
  box-sizing: border-box;
  flex: 0 0 100%;
  max-width: 100%;
  min-height: 1px;
  padding-left: 8px;
  padding-right: 8px;
  position: relative;
  width: 100%;
`

export const Wrapper = styled.div`
  width: 100%;
  padding: 80px 0;
  max-width: 484px;
  margin: 0 auto;

  @media ${mobileQuery} {
    padding: 40px 16px;
  }

  @media ${twoColumnQuery} {
    ${SignupHalfColumn} {
      flex-basis: 50%;
      max-width: 50%;
    }
  }
`
